import { AddDeviceStep } from 'entities/device.add/model/type';
import { SerialInput } from 'entities/device.add/ui/serial';
import { AddSimWizard } from 'entities/device.add/ui/sim';
import { Wifi } from 'entities/device.add/ui/wifi';
export const stepsSpec = {
    [AddDeviceStep.InputSerial]: {
        title: 'Ввод серийного номера',
        Component: SerialInput,
    },
    [AddDeviceStep.AddSim]: { title: 'Добавление сим-карты', Component: AddSimWizard },
    [AddDeviceStep.AddWiFi]: {
        title: 'Подключение к Wi-Fi сети',
        Component: Wifi,
    },
};
